export const mobileScreenType = "mobile";
export const tabletScreenType = "tablet";
export const desktopScreenType = "desktop";
export const largeDisplayScreenType = "largeDisplay";
